var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7825 3.21843C20.6813 3.11768 20.5534 3.04793 20.4139 3.01737C20.2744 2.98681 20.1291 2.99672 19.995 3.04593L3.495 9.04593C3.3527 9.0999 3.23019 9.19589 3.14374 9.32114C3.05729 9.44639 3.01099 9.59498 3.01099 9.74718C3.01099 9.89937 3.05729 10.048 3.14374 10.1732C3.23019 10.2985 3.3527 10.3945 3.495 10.4484L10.695 13.3284L13.575 20.5284C13.6291 20.6645 13.7219 20.7817 13.8418 20.8657C13.9618 20.9496 14.1037 20.9967 14.25 21.0009C14.4016 20.9978 14.5486 20.9489 14.6718 20.8605C14.795 20.7721 14.8885 20.6485 14.94 20.5059L20.94 4.00593C20.9911 3.87323 21.0034 3.72875 20.9755 3.58932C20.9477 3.44989 20.8807 3.32126 20.7825 3.21843ZM14.25 18.1509L12.1575 12.9009L15.75 9.30843L14.6925 8.25093L11.07 11.8734L5.85 9.75093L18.9975 5.00343L14.25 18.1509Z",
    fill: "#99A1B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSent);
export default __webpack_public_path__ + "static/media/ic-sent.84d49272fc9602911e6a13e3b4ff6a1f.svg";
export { ForwardRef as ReactComponent };